import { Field, Int } from '@nestjs/graphql'
import { BaseUpdateDto } from '../base/baseUpdate.dto'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class UpdateArcTeamDto extends BaseUpdateDto<UpdateArcTeamDto> {
  @Field(type => String, { nullable: true })
  name?: string

  @Field(type => String, { nullable: true })
  image?: string

  @Field(type => String, { nullable: true })
  description?: string

  @Field(type => Int, { nullable: true })
  defaultDisclaimer?: number

  @Field(t => [String], { nullable: true })
  autoApproveEmailAddresses?: string[]

  @Field(t => [String], { nullable: true })
  autoBlockEmailAddresses?: string[]

  @Field(t => [String], { nullable: true })
  autoVipEmailAddresses?: string[]
}
